import script from "./Boletos.vue?vue&type=script&setup=true&lang=js"
export * from "./Boletos.vue?vue&type=script&setup=true&lang=js"

import "./Boletos.vue?vue&type=style&index=0&id=78ad860b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ad860b"]])

export default __exports__